import l from "classnames";
import i, { forwardRef as u } from "react";
import { useSizeAttrs as w } from "../utils/hooks/useSizeAttrs.esm.js";
const h = "_swatch_51ouf_1", d = {
  swatch: h
}, f = {
  small: "small",
  medium: "medium",
  large: "large"
}, n = u(({ dataTestId: s, imageSrc: t, colour: a, className: e, size: c = "medium", ...m }, o) => {
  const r = w(c, f);
  return /* @__PURE__ */ i.createElement(
    "span",
    {
      ref: o,
      className: l(d.swatch, e, "fuse-swatch"),
      "data-testid": s,
      ...m,
      ...r,
      style: {
        "--swatch-img-url": t ? `url('${t}')` : void 0,
        "--swatch-colour": a
      }
    }
  );
});
n.displayName = "Swatch";
export {
  n as Swatch
};
